var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',_vm._b({staticClass:"inline-block h-em w-em pointer-events-none align-middle",class:[
    _vm.data.staticClass,
    _vm.data.class,
    {
      'fill-current':
        (_vm.data.staticClass &&
          _vm.data.staticClass.indexOf('fill-current') !== -1) ||
        (_vm.data.staticClass && _vm.data.staticClass.indexOf('fill-') === -1) ||
        (_vm.data.class && _vm.data.class.indexOf('fill-') === -1),
    } ],attrs:{"viewBox":"0 0 24 24","height":"24","width":"24","role":"img"}},'svg',_vm.data.attrs,false),[_c('use',{attrs:{"xlink:href":"#" + (_vm.props.dataId || "inspiration")}})])}
var staticRenderFns = []

export { render, staticRenderFns }